import React, { useEffect, useState } from 'react';

import { bemCssModules } from '@src/utils/index';

import Curve from './curve.svg';
import FaceBackground from './face_background.svg';
import StarFilled from './star_filled.svg';
import StarSolid from './star_solid.svg';

import style from './Illustration.scss';

const cn = bemCssModules(style, 'Illustration');

const Illustration: CustomFC = ({ className }) => {
  const faceSrc = '/img/kyc-face.png';
  const [showFace, setShowFace] = useState(false);

  useEffect(() => {
    const image = new Image();
    image.onload = () => setShowFace(true);
    image.src = faceSrc;
  }, []);

  return (
    <div className={cn(null, [className])}>
      <div className={cn('container')}>
        <div className={cn('face')}>
          <img
            draggable={false}
            className={cn('face-pic', { hidden: !showFace })}
            src={faceSrc}
            alt="face"
          />
        </div>
        {showFace && (
          <>
            <div className={cn('face-background')}>
              <FaceBackground className={cn('face-background-pic')} />
            </div>
            <div className={cn('curve')}>
              <Curve className={cn('curve-pic')} />
            </div>
            <div className={cn('star-top-solid')}>
              <StarSolid className={cn('star-top-solid-pic')} />
            </div>
            <div className={cn('star-top-filled')}>
              <StarFilled className={cn('star-top-filled-pic')} />
            </div>
            <div className={cn('star-bottom-solid')}>
              <StarSolid className={cn('star-bottom-solid-pic')} />
            </div>
            <div className={cn('star-bottom-filled')}>
              <StarFilled className={cn('star-bottom-filled-pic')} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Illustration;
